import type { RoleType } from "@domain/General/Enums/RoleType";
import type { IDealerModeRole, IDealerModeRoleDto } from "./IDealerModeRole";

export class DealerModeRole implements IDealerModeRole
{
    name: string;
    userContextId: string;
    clientId: string;
    clientName: string;
    roleType: RoleType;
    appIds: string[];
    permissions: string[];

    constructor( model: IDealerModeRoleDto )
    {
        this.name = model.name;
        this.userContextId = model.userContextId;
        this.clientId = model.clientId;
        this.clientName = model.clientName;
        this.roleType = model.roleType;
        this.appIds = model.appIds;
        this.permissions = model.permissions;
    }
}
